import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MouseUIProvider, ToastProvider } from 'mouse-user-interface';
import App from './App';
import 'mouse-user-interface/dist/theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MouseUIProvider>
        <ToastProvider position='top-right'>
          <App />
        </ToastProvider>
      </MouseUIProvider>
    </BrowserRouter>
  </React.StrictMode>
);
